import React from 'react';
import {Provider} from 'react-redux';

import {AppReduxContext} from './context';
import {store} from './store';

import type {ReactNode as Node} from 'react';

type Props = {
    children: Node,
};
export const AppStateProvider = ({children}: Props) => (
    <Provider store={store} context={AppReduxContext}>
        {children}
    </Provider>
);
